import { Injectable } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

export interface ConfirmOptions {
  message: string;
  header?: string;
  acceptLabel?: string;
  rejectLabel?: string;
  acceptSeverity?: 'primary' | 'danger';
}

/** Thin wrapper around PrimeNG ConfirmationService for consistent confirm dialogs. */
@Injectable({ providedIn: 'root' })
export class ConfirmDialogService {
  constructor(
    private readonly confirmationService: ConfirmationService,
    private readonly translate: TranslateService,
  ) {}

  confirm(opts: ConfirmOptions): Promise<boolean> {
    return new Promise((resolve) => {
      this.confirmationService.confirm({
        message: opts.message,
        header: opts.header ?? this.translate.instant('common.confirm'),
        acceptLabel: opts.acceptLabel ?? this.translate.instant('common.confirm'),
        rejectLabel: opts.rejectLabel ?? this.translate.instant('common.cancel'),
        acceptButtonStyleClass: opts.acceptSeverity === 'danger' ? 'p-button-danger' : undefined,
        accept: () => resolve(true),
        reject: () => resolve(false),
      });
    });
  }

  delete(itemName: string): Promise<boolean> {
    return this.confirm({
      header: this.translate.instant('dialogs.delete.title'),
      message: this.translate.instant('dialogs.delete.message', { itemName }),
      acceptLabel: this.translate.instant('dialogs.delete.confirmButton'),
      acceptSeverity: 'danger',
    });
  }
}
